import { LMSUserResponse } from '@nimbly-technologies/nimbly-common';
import { createAsyncAction } from 'typesafe-actions';
import * as types from './lmsUserManagementUserById.actionTypes';

export const fetchLmsUserByIdAsync = createAsyncAction(
	types.FETCH_LMS_USER_MANAGEMENT_USER_BY_ID_REQUEST,
	types.FETCH_LMS_USER_MANAGEMENT_USER_BY_ID_SUCCESS,
	types.FETCH_LMS_USER_MANAGEMENT_USER_BY_ID_FAILURE,
)<{ userID: string }, LMSUserResponse, string>();
